var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckOn = function SvgCheckOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D6",
    d: "M2 2h20v20H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.817 17.048 6 12.308l1.29-1.036 2.606 3.24 6.88-7.552L18 8.074l-8.183 8.974Z",
    fill: "#fff"
  })));
};
export { SvgCheckOn as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSIgZmlsbD0iIzAwNzhENiIvPgo8cGF0aCBkPSJNOS44MTcgMTcuMDQ4TDYgMTIuMzA4TDcuMjkgMTEuMjcyTDkuODk2IDE0LjUxMkwxNi43NzYgNi45NjAwMkwxOCA4LjA3NDAyTDkuODE3IDE3LjA0OFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";